import { render, staticRenderFns } from "./TournamentEntry.vue?vue&type=template&id=befe491c&scoped=true"
import script from "./TournamentEntry.vue?vue&type=script&lang=js"
export * from "./TournamentEntry.vue?vue&type=script&lang=js"
import style0 from "./TournamentEntry.vue?vue&type=style&index=0&id=befe491c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befe491c",
  null
  
)

export default component.exports